import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.editModel ? _c('div', [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.executionResult'),
      "open": _vm.executionResultPrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        color: 'red',
        emit: 'close'
      }]
    },
    on: {
      "close": function ($event) {
        _vm.executionResultPrompt = false;
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.lastExecutionResult) + "\n  ")]), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    },
    attrs: {
      "align": "top"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$i18n_t('AlarmLogs.reports.wizard.condition')))])]), _c('div', {
    staticClass: "mx-2 my-3",
    staticStyle: {
      "display": "flex",
      "flex-direction": "row",
      "justify-content": "space-between",
      "align-items": "center",
      "min-width": "650px"
    }
  }, [_c('div', {
    staticClass: "mx-1",
    staticStyle: {
      "display": "flex",
      "min-width": "90px"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('AlarmLogs.reports.wizard.triggerIf')) + "\n      ")]), _c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      "items": _vm.reportExecuteConditions,
      "return-object": false,
      "color": _vm.color,
      "label": _vm.$i18n_t('AlarmLogs.reports.wizard.triggerIf'),
      "rules": _vm.requiredRule,
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editModel.filters.condition,
      callback: function ($$v) {
        _vm.$set(_vm.editModel.filters, "condition", $$v);
      },
      expression: "editModel.filters.condition"
    }
  })], 1)], 1), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    },
    attrs: {
      "align": "top"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$i18n_t('AlarmLogs.reports.wizard.actions')))])])], 1), _c(VRow, {
    class: _vm.editModel.filters.originType !== 'smartgroup-packet-monitoring' ? '' : 'pb-7',
    staticStyle: {
      "min-width": "0"
    },
    attrs: {
      "align": "top"
    }
  }, [_c(VCol, {
    staticClass: "px-7",
    attrs: {
      "cols": "12"
    }
  }, [_c('core-timezone-selector', {
    attrs: {
      "rules": _vm.requiredRule,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.timeZone'),
      "required": ""
    },
    model: {
      value: _vm.editModel.timeTrigger.timeZone,
      callback: function ($$v) {
        _vm.$set(_vm.editModel.timeTrigger, "timeZone", $$v);
      },
      expression: "editModel.timeTrigger.timeZone"
    }
  })], 1)], 1), _vm.editModel.filters.originType !== 'smartgroup-packet-monitoring' ? _c(VRow, {
    staticClass: "pb-7 pt-0 mt-0",
    staticStyle: {
      "min-width": "0"
    },
    attrs: {
      "align": "top"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "card-description mb-0"
  }, [_vm._v(_vm._s(_vm.$i18n_t('AlarmLogs.reports.wizard.timePickerText')))])]), _c(VCol, {
    staticClass: "px-7",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VSelect, {
    attrs: {
      "items": _vm.weekDayOptions,
      "label": _vm.$i18n_t('Common.WeekDay'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "multiple": "",
      "chips": "",
      "hide-details": ""
    },
    on: {
      "input": function ($event) {
        return _vm.handleDaysSelection('weekDays');
      }
    },
    model: {
      value: _vm.editModel.timeTrigger.weekDays,
      callback: function ($$v) {
        _vm.$set(_vm.editModel.timeTrigger, "weekDays", $$v);
      },
      expression: "editModel.timeTrigger.weekDays"
    }
  })], 1), _c(VCol, {
    staticClass: "px-7",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VSelect, {
    attrs: {
      "items": _vm.monthDaysOptions,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.monthDays'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "multiple": "",
      "chips": "",
      "hide-details": ""
    },
    on: {
      "input": function ($event) {
        return _vm.handleDaysSelection('monthDays');
      }
    },
    model: {
      value: _vm.editModel.timeTrigger.monthDays,
      callback: function ($$v) {
        _vm.$set(_vm.editModel.timeTrigger, "monthDays", $$v);
      },
      expression: "editModel.timeTrigger.monthDays"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('core-dateTime-picker', {
    attrs: {
      "from": new Date(_vm.editModel.timeTrigger.dateStart) / 1000,
      "expandIcon": "",
      "allowNull": "",
      "dateOnly": "",
      "futureRange": "",
      "hideBorderOnCollapse": ""
    },
    on: {
      "date:picked": e => _vm.startDatePicked(e)
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function ({
        startDate
      }) {
        return [_c(VTextField, {
          attrs: {
            "value": startDate,
            "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.startDate'),
            "color": _vm.color,
            "outlined": _vm.inpOutlined,
            "filled": _vm.inpFilled,
            "append-icon": "fal fa-calendar-day",
            "readonly": "",
            "disabled": "",
            "hide-details": ""
          }
        })];
      }
    }], null, false, 3577837146)
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('core-dateTime-picker', {
    attrs: {
      "from": new Date(_vm.editModel.timeTrigger.dateEnd) / 1000,
      "expandIcon": "",
      "allowNull": "",
      "dateOnly": "",
      "futureRange": "",
      "hideBorderOnCollapse": ""
    },
    on: {
      "date:picked": e => _vm.endDatePicked(e)
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function ({
        startDate
      }) {
        return [_c(VTextField, {
          attrs: {
            "value": startDate,
            "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.endDate'),
            "color": _vm.color,
            "outlined": _vm.inpOutlined,
            "filled": _vm.inpFilled,
            "append-icon": "fal fa-calendar-day",
            "readonly": "",
            "disabled": "",
            "hide-details": ""
          }
        })];
      }
    }], null, false, 42306101)
  })], 1)], 1) : _vm._e(), _vm.commands.length === 0 ? [_c('core-n20-card', {
    staticClass: "dt-card-text-01 payload"
  }, [_c(VAlert, {
    staticClass: "mb-1",
    staticStyle: {
      "padding-left": "0px",
      "padding-top": "5px"
    },
    attrs: {
      "value": true,
      "color": "transparent",
      "icon": "fal fa-exclamation-circle"
    }
  }, [_c('span', [_vm._v("\n          " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.emails.noCofiguredEmails')) + "\n        ")])]), _vm._v("\n      " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.emails.useEmailSendout')) + "\n    ")], 1)] : _vm._l(_vm.editModel.actions, function (action, i) {
    var _vm$findCommandById2;
    return _c('core-n20Card', {
      key: `action_${i}`,
      class: `${i === 0 ? 'mt-12' : ''} ${_vm.actionsN20CardClass}`,
      scopedSlots: _vm._u([{
        key: "buttons",
        fn: function () {
          return [_c(VBtn, {
            class: 'v-btn-x px-3 mx-1 v-btn--rounded bg-rounded-button-' + _vm.color,
            attrs: {
              "color": _vm.color,
              "rounded": "",
              "text": ""
            },
            on: {
              "click": function ($event) {
                return _vm.testExecuteAction(i);
              }
            }
          }, [_c(VIcon, {
            attrs: {
              "dark": ""
            }
          }, [_vm._v("fal fa-rocket")]), _vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.execute')) + "\n        ")], 1), _vm.editModel.actions.length > 1 ? _c(VBtn, {
            class: 'v-btn-x mx-1 v-btn--rounded bg-rounded-button-' + _vm.color,
            attrs: {
              "color": _vm.color,
              "title": _vm.$i18n_t('Common.delete'),
              "icon": "",
              "info": "",
              "fab": "",
              "text": ""
            },
            on: {
              "click": function ($event) {
                return _vm.deleteReportAction(i);
              }
            }
          }, [_c(VIcon, {
            attrs: {
              "dark": ""
            }
          }, [_vm._v("fal fa-trash-alt")])], 1) : _vm._e(), _c(VBtn, {
            class: 'v-btn-x mx-1 v-btn--rounded bg-rounded-button-' + _vm.color,
            attrs: {
              "color": _vm.color,
              "title": _vm.$i18n_t('Common.addNew'),
              "icon": "",
              "info": "",
              "fab": "",
              "text": ""
            },
            on: {
              "click": function ($event) {
                return _vm.addReportAction(i);
              }
            }
          }, [_c(VIcon, {
            attrs: {
              "dark": ""
            }
          }, [_vm._v("fal fa-plus")])], 1)];
        },
        proxy: true
      }], null, true)
    }, [_c('div', {
      staticClass: "commands"
    }, [_c('div', {
      staticClass: "my-3",
      staticStyle: {
        "display": "flex",
        "flex-direction": "row",
        "justify-content": "flex-start",
        "align-items": "center",
        "min-width": "650px"
      }
    }, [_c('div', {
      staticClass: "mx-3",
      staticStyle: {
        "display": "flex"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.doExecute')) + "\n          ")]), _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c(VSelect, {
      staticClass: "action-command required",
      attrs: {
        "items": _vm.commands,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": _vm.requiredRule,
        "item-text": "name",
        "item-value": "id",
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.command'),
        "error": _vm.commands.length === 0 ? _vm.$i18n_t('AlarmLogs.reports.wizard.noMatchingConnectors') : null,
        "hide-details": ""
      },
      on: {
        "change": function ($event) {
          return _vm.commandAtIdxDidChange(i);
        }
      },
      model: {
        value: action.command,
        callback: function ($$v) {
          _vm.$set(action, "command", $$v);
        },
        expression: "action.command"
      }
    })], 1)]), action.command ? _c(VRow, {
      staticStyle: {
        "min-width": "0"
      },
      attrs: {
        "align": "top"
      }
    }, [_vm._l(_vm.orderedParamKeysForCommandId(action.command), function (param, j) {
      var _vm$findCommandById;
      return _c(VCol, {
        key: `actionparam_${i}_${j}`,
        attrs: {
          "cols": "12",
          "sm": "6",
          "md": "4",
          "lg": _vm.getColumnWidth(param, _vm.parametersForCommandId(action.command)[param])
        }
      }, [_c('core-tenant-bridge-config-field', {
        attrs: {
          "disabled": param === 'from' && ((_vm$findCommandById = _vm.findCommandById(action.command)) === null || _vm$findCommandById === void 0 || (_vm$findCommandById = _vm$findCommandById.config) === null || _vm$findCommandById === void 0 ? void 0 : _vm$findCommandById.service) === 'Outlook365(OAuth2.0)',
          "fieldConfig": _vm.parametersForCommandId(action.command)[param],
          "bridgeType": _vm.findCommandById(action.command).bridgeType,
          "configKey": param,
          "bridgeManifest": _vm.findCommandById(action.command).manifest,
          "bridgeConfig": _vm.findCommandById(action.command).config,
          "bridgeConfigId": _vm.findCommandById(action.command).configId,
          "defaultIcon": null,
          "bridgeHasValidParametersStrict": false,
          "bridgeHasValidParameters": "",
          "brigdeHasError": ""
        },
        model: {
          value: action.params[param],
          callback: function ($$v) {
            _vm.$set(action.params, param, $$v);
          },
          expression: "action.params[param]"
        }
      })], 1);
    }), _c(VCol, {
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "4"
      }
    }, [_c(VSelect, {
      staticClass: "required",
      attrs: {
        "items": _vm.localeOptions,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": _vm.requiredRule,
        "label": _vm.$i18n_t('AlarmLogs.reports.wizard.reportLanguage'),
        "hide-details": "auto"
      },
      model: {
        value: action.params['locale'],
        callback: function ($$v) {
          _vm.$set(action.params, 'locale', $$v);
        },
        expression: "action.params['locale']"
      }
    })], 1)], 2) : _vm._e(), action.command ? _c(VRow, {
      staticStyle: {
        "min-width": "0"
      },
      attrs: {
        "align": "top"
      }
    }, [_c(VCol, {
      attrs: {
        "cols": "12"
      }
    }, [_c('p', {
      staticClass: "card-description mb-0"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.$i18n_t('AlarmLogs.reports.wizard.subjectPlacerholderText'))
      }
    }), _vm.editModel.filters.originType === 'smartgroup-packet-monitoring' ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.$i18n_t('AlarmLogs.reports.wizard.subjectPlaceholderPacketThreshold'))
      }
    }) : _vm._e()])]), _c(VCol, {
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('core-tenant-bridge-config-field', {
      attrs: {
        "disabled": _vm.param === 'from' && ((_vm$findCommandById2 = _vm.findCommandById(action.command)) === null || _vm$findCommandById2 === void 0 || (_vm$findCommandById2 = _vm$findCommandById2.config) === null || _vm$findCommandById2 === void 0 ? void 0 : _vm$findCommandById2.service) === 'Outlook365(OAuth2.0)',
        "fieldConfig": _vm.parametersForCommandId(action.command)['subject'],
        "bridgeType": _vm.findCommandById(action.command).bridgeType,
        "configKey": 'subject',
        "bridgeManifest": _vm.findCommandById(action.command).manifest,
        "bridgeConfig": _vm.findCommandById(action.command).config,
        "bridgeConfigId": _vm.findCommandById(action.command).configId,
        "defaultIcon": null,
        "bridgeHasValidParametersStrict": false,
        "bridgeHasValidParameters": "",
        "brigdeHasError": ""
      },
      model: {
        value: action.params['subject'],
        callback: function ($$v) {
          _vm.$set(action.params, 'subject', $$v);
        },
        expression: "action.params['subject']"
      }
    })], 1)], 1) : _vm._e(), action.command && _vm.editModel.filters.originType !== 'smartgroup-packet-monitoring' ? _c(VRow, {
      staticStyle: {
        "min-width": "0"
      },
      attrs: {
        "align": "top"
      }
    }, [_c(VCol, {
      attrs: {
        "cols": "12"
      }
    }, [_c('p', {
      staticClass: "card-description mb-0"
    }, [_vm._v(_vm._s(_vm.$i18n_t('AlarmLogs.reports.wizard.tables')))])]), _c(VCol, {
      staticClass: "py-0",
      attrs: {
        "cols": "12"
      }
    }, [_c(VAutocomplete, {
      staticClass: "required",
      attrs: {
        "rules": _vm.requiredRule,
        "items": _vm.tablesItems,
        "return-object": false,
        "color": _vm.color,
        "label": _vm.$i18n_t('AlarmLogs.reports.wizard.tables'),
        "outlined": "",
        "chips": "",
        "multiple": ""
      },
      on: {
        "input": function ($event) {
          return _vm.handleTablesSelected(i);
        }
      },
      model: {
        value: action.tables,
        callback: function ($$v) {
          _vm.$set(action, "tables", $$v);
        },
        expression: "action.tables"
      }
    })], 1)], 1) : _vm._e()], 1)]);
  }), _c('core-button', {
    attrs: {
      "disabled": !_vm.formValid,
      "color": _vm.color,
      "appendIcon": "fa-check"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('submitReport');
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.editModel.id ? _vm.$i18n_t('AlarmLogs.reports.wizard.updateButton') : _vm.$i18n_t('AlarmLogs.reports.wizard.createButton')) + "\n  ")])], 2) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };